import { create } from 'zustand';

export interface GameRules {
  quiz: string;
  swipe: string;
  ring: string;
}

interface GameRulesState {
  rules: GameRules;
  setRules: (rules: Partial<GameRules>) => void;
  getRules: () => GameRules;
}

const defaultRules: GameRules = {
  quiz: "En participant au Quiz Politique, votre parti accepte que les résultats soient générés de manière automatique en fonction de vos réponses aux questions, afin d'alimenter les correspondances ludiques avec les citoyens. Vous vous engagez à accepter ces résultats sans contestation, dans un esprit de jeu démocratique transparent.",
  swipe: "Le jeu Match ton Parti (Swipe) vise à créer des affinités politiques avec les électeurs. En cochant vos positions, vous acceptez que la plateforme calcule un score de compatibilité de façon neutre et automatisée. Votre parti accepte le verdict ludique du swipe comme partie intégrante de son engagement citoyen.",
  ring: "La participation au Ring implique le respect d'une charte de débat strict. En soumettant vos contributions, vous acceptez le format court, l'absence d'attaques personnelles, et vous reconnaissez que les réactions et le jugement de la communauté citoyenne (tags, scores) reflètent la nature dynamique de l'arène sans pouvoir engager la responsabilité de la plateforme."
};

export const useGameRulesStore = create<GameRulesState>((set, get) => ({
  rules: {
    quiz: localStorage.getItem("kaynin_rules_quiz") || defaultRules.quiz,
    swipe: localStorage.getItem("kaynin_rules_swipe") || defaultRules.swipe,
    ring: localStorage.getItem("kaynin_rules_ring") || defaultRules.ring,
  },
  setRules: (newRules) => {
    set((state) => {
      const updated = { ...state.rules, ...newRules };
      if (newRules.quiz) localStorage.setItem("kaynin_rules_quiz", newRules.quiz);
      if (newRules.swipe) localStorage.setItem("kaynin_rules_swipe", newRules.swipe);
      if (newRules.ring) localStorage.setItem("kaynin_rules_ring", newRules.ring);
      return { rules: updated };
    });
  },
  getRules: () => get().rules,
}));
